import UserAccessDataRepositoryImpl from './impl/UserAccessDataRepositoryImpl'

export default {
  getInstance () {
    return new UserAccessDataRepositoryImpl()
  }
}
